import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "placeholder", "required"]
const _hoisted_3 = { class: "c-form_validation" }
const _hoisted_4 = { class: "c-form_validation_required" }
const _hoisted_5 = { class: "c-form_validation_invalid" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      for: $props.id,
      class: _normalizeClass(["c-form_label", {'-required': $props.required}])
    }, _toDisplayString($props.labelText), 11 /* TEXT, CLASS, PROPS */, _hoisted_1),
    _createElementVNode("textarea", {
      class: "c-form_textarea",
      id: $props.id,
      name: $props.name,
      placeholder: $props.placeholder,
      required: $props.required
    }, "        " + _toDisplayString($props.modelValue) + "\n    ", 9 /* TEXT, PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx._t("Enter a value for this field.")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx._t("This field is invalid.")), 1 /* TEXT */)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}